<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[
        { name: 'Products', to: { path: '/products' } },
        { name: 'Product Info', to: { path: '/products/product-info' } },
        { name: 'Edit', to: { path: '/products/product-info/edit' } },
        {
          name: 'Edit Spec',
          to: { path: '/products/product-info/edit/edit-spec' },
        },
      ]"
    >
    </Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯子分類</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!-- Spec block -->
    <div class="d-flex">
      <!-- Title and description -->
      <div class="w-300px mr-5">
        <h3 class="mb-10px">Filter</h3>
        <div>
          Filter會顯示於Product Category Page <br />
          同SubCategory的產品將同步Filter種類
        </div>
      </div>
      <!-- Filters -->
      <div class="block flex-grow-1 flex-basis-0">
        <!-- add -->
        <div class="d-flex pa-5 brand-100">
          <div class="d-flex my-n2 flex-grow-1">
            <div class="ml-auto">
              <filterDialog @add-filter="addItem"></filterDialog>
            </div>
          </div>
        </div>

        <!--<div class="form-item d-flex px-5 py-3">-->
          <!--<div class="d-flex flex-grow-1 align-center">-->
            <!--<h4 class="mr-1 w-230px">-->
              <!--<span>子分類</span>-->
              <!--<span>(SubCategory)</span>-->
            <!--</h4>-->
            <!--<v-checkbox v-model="subcategory.is_filter"></v-checkbox>-->
          <!--</div>-->
        <!--</div>-->
        <!-- items -->
        <div
          class="form-item d-flex px-5 py-3"
          v-for="(item, i) in subcategory.specs"
          :key="item.id"
        >
          <div class="d-flex flex-grow-1 align-center">
            <h4 class="mr-1 w-230px">
              <span>{{ item.title }}</span>
              <span v-if="item.is_customized == true">
                (Customized)
              </span>
            </h4>
            <v-checkbox v-model="item.is_filter"></v-checkbox>
          </div>
          <div class="ml-5">
            <button
              class="btn square mr-10px"
              @click="editItem(item)"
              v-if="item.is_customized == true"
            >
              <v-icon>edit</v-icon>
            </button>
            <button
              class="btn square mr-10px"
              @click="deleteItem(item)"
              v-if="item.is_customized == true"
            >
              <v-icon>delete</v-icon>
            </button>
            <button class="btn square mr-10px" @click="downItem(item, i)">
              <v-icon>arrow_downward</v-icon>
            </button>
            <button class="btn square" @click="upItem(item, i)">
              <v-icon>arrow_upward</v-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import filterDialog from '@/views/C-2__SubCategory/c/C-2-2-2-1__SubCategory_DialogCustomized-Filter-Create.vue';

export default {
  components: {
    Breadscrumbs,
    filterDialog,
  },
  data: () => ({
    isOpen: false,
    filterData: {},
  }),
  async created() {
    if (this.$route.params.id) {
      await this.getSubCategory(this.$route.params.id);
    }
  },
  computed: {
    ...mapState('subcategory', [
      'subcategory',
    ]),
  },
  methods: {
    ...mapActions('subcategory', {
      setFilterData: 'setFilterData',
      toggleFilterDialog: 'toggleFilterDialog',
      getSubCategory: 'findById',
      saveSubCategory: 'save',
    }),
    addItem(item) {
      const template = {
        id: null,
        is_customized: true,
        title: item.title,
        options: item.options,
      };

      this.subcategory.specs.push(template);
    },
    editItem(item) {
      this.setFilterData(item);
      this.toggleFilterDialog(true);
    },
    deleteItem(item) {
      const index = this.subcategory.specs.map((option) => option.id).indexOf(item.id);
      this.subcategory.specs.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.subcategory.specs.length - 1) {
        this.subcategory.specs.splice(i, 1);
        this.subcategory.specs.unshift(item);
        return;
      }
      // item become next index
      this.subcategory.specs.splice(i, 1);
      this.subcategory.specs.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.subcategory.specs.splice(i, 1);
        this.subcategory.specs.push(item);
        return;
      }
      // item become previous index
      this.subcategory.specs.splice(i, 1);
      this.subcategory.specs.splice(i - 1, 0, item);
    },
    cancelHandler() {
      this.$router.go(-1);
    },
    saveHandler() {
      const { getSubCategory, $router } = this;
      this.saveSubCategory(this.subcategory).then(() => {
        getSubCategory(this.subcategory.id);
        $router.go(-1);
      });
    },
  },
};
</script>

<style></style>
